// Automatische Konfiguration:
// Lokal (Entwicklung): Nutzt http://localhost/f1-league (oder was du eingestellt hast)
// Produktion (IONOS): Nutzt "." (aktueller Ordner), damit PHP-Dateien direkt gefunden werden.

// Safe detection of environment using window.location instead of import.meta.env
// to avoid "undefined is not an object" errors in environments where Vite env is missing.

const hostname = window.location.hostname;
const port = window.location.port;

const isLocal = hostname === 'localhost' || hostname === '127.0.0.1';

// We assume Dev Mode (needing absolute URL) if:
// 1. We are on localhost/127.0.0.1
// 2. AND we are on a specific port (like 5173), NOT default web ports (80/443/empty)
// This separates "Vite Dev Server" from "Local Production Build via XAMPP"
const isDevServer = isLocal && port !== '' && port !== '80' && port !== '443';
const isAIStudio = hostname.includes('run.app');

export const API_BASE_URL = (isDevServer && !isAIStudio) ? '/api' : '.';
